import {Injectable} from '@angular/core';
import {CanActivate, CanActivateChild, Router, ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router';
import {Observable} from 'rxjs/Observable';
import {AuthService} from './auth.service';
import {PdfExportService} from '../services/export-pdf/pdf-export.service';
import {UserService} from '../services/user.service';
import {WebUtils} from '../utils/web.utils';


@Injectable()
export class PdfGuard implements CanActivate, CanActivateChild {
  constructor(private pdfService: PdfExportService, private userService: UserService) {

  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    this.pdfService.updateExportingPdf(true);
    this.pdfService.resetImageCounter();
    this.pdfService.resetListReadyReport();
    const activeAccount = WebUtils.extractActiveAccountFromUrl();
    this.userService.manuallyUpdateActiveAccount(activeAccount);
    return true;
  }

  canActivateChild(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    return this.canActivate(route, state);
  }
}



// WEBPACK FOOTER //
// ./src/app/core/pdf.guard.ts